// import { AnalyticsBrowser } from '@segment/analytics-next'

class SegmentAnalytics {
//   constructor() {
//     this.analytics = AnalyticsBrowser.load({ writeKey: SEGMENT_KEY })
//   }

  // User Identifies
  userLogIn = (user) => {
    const userId = user.id
    const userInfo = {
      email: user.email,
      name: `${user.firstname} ${user.lastname}`.trim(),
      first_name: user.firstname,
      last_name: user.lastname,
      role: user.role,
      company_id: user.company && user.company.id,
    }
    window.analytics.identify(userId, userInfo)
    this.userId = userId
    this.userInfo = userInfo

    if (user.company) {
      window.analytics.group(user.company.id, {
        company_name: user.company.name,
      })
    }
  }

  userLogOut = () => window.analytics.reset();

  // Order Accepted
  orderAccepted = () => {
    window.analytics.track('Order Accepted', {})
  };

  track(eventName, params) {
    window.analytics.track(eventName, { ...params })
  }

  page(name, data) {
    window.analytics.page(name, data)
  }

  inspectionAvailability() {
    window.analytics.page('Inspection Availability')
  }
}

const analytics = new SegmentAnalytics()

export default analytics
